import { SubscriptionsWidgetStatisticsState } from '@pages/home/store/states/subscriptions-widget-statistics.state';
import { InsightsDataState } from '@pages/home/store/states/insights.state';
import { OrdersState } from '@pages/home/store/states/orders.state';
import { FeaturesSetupWidgetState } from '@pages/home/store/states/features-setup-widget.state';
import { VideoTutorialsSummaryWidgetState } from '@pages/home/store/states/video-tutorials-widget.state';
import { InsightModulesScoreState } from '@pages/home/store/states/insight-modules-score.state';
import { MyModulesWidgetSettingsState } from '@pages/home/store/states/my-modules-widget-settings.state';
import { InsightsSettingsState } from '@pages/home/store/states/insights-settings.state';

export const homeState = [
  SubscriptionsWidgetStatisticsState,
  InsightsDataState,
  InsightsSettingsState,
  OrdersState,
  FeaturesSetupWidgetState,
  VideoTutorialsSummaryWidgetState,
  InsightModulesScoreState,
  MyModulesWidgetSettingsState,
];
